import { render, staticRenderFns } from "./UserDropdownOption.vue?vue&type=template&id=39257364&"
import script from "./UserDropdownOption.vue?vue&type=script&lang=js&"
export * from "./UserDropdownOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports